/**
 * MESSAGE INFO API — Wrapper REST Liferay allineato a MessagesResourceImpl.java.
 *
 * Unico endpoint esposto al client (vedi rest-openapi.yaml):
 *   - PATCH /message/{messageId}/info/{messageInfoId}   MessageInfoInput -> MessageInfo
 *
 * Create e delete non sono esposti via REST: le info vengono popolate
 * lato server da altri servizi, il client puo' solo modificare value e
 * priority di un'info esistente.
 *
 * Il fetch delle info avviene implicitamente via Message.infos eager-load
 * (vedi messageApi.getAll / getById): non serve un endpoint list dedicato.
 */

import { httpClient } from '../../api/httpClient';
import {
  messageInfoFromDto,
  messageInfoUpdateToInput,
  type MessageInfoDto,
} from './messageInfoMappers';
import type { MessageInfo, MessageInfoUpdatePayload } from './messageInfoTypes';

const SINGLE = '/message';

export const messageInfoApi = {
  update: (
    messageId: number,
    messageInfoId: number,
    payload: MessageInfoUpdatePayload,
  ): Promise<MessageInfo> =>
    httpClient
      .patch<MessageInfoDto>(
        `${SINGLE}/${messageId}/info/${messageInfoId}`,
        messageInfoUpdateToInput(payload),
      )
      .then((r) => messageInfoFromDto(r.data)),
};
